import { create } from 'zustand';

export interface Plan {
  key: string;
  name: string;
  price: number;
  priceAnnual: number | null;
  annualTotal: number | null;
  credits: number;
  monthlyAllocation: number;
  features: string[];
  firstMonthPromo: string | null;
}

export interface SubscriptionStatus {
  plan: string;
  balance: number;
  monthlyAllocation: number;
  subscriptionStatus: string | null;
  currentPeriodEnd: string | null;
}

interface SubscriptionState {
  plans: Plan[];
  status: SubscriptionStatus | null;
  isLoadingPlans: boolean;
  isLoadingStatus: boolean;
  error: string | null;
  setPlans: (plans: Plan[]) => void;
  setStatus: (status: SubscriptionStatus | null) => void;
  setLoadingPlans: (loading: boolean) => void;
  setLoadingStatus: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

const useSubscriptionStore = create<SubscriptionState>((set) => ({
  plans: [],
  status: null,
  isLoadingPlans: false,
  isLoadingStatus: false,
  error: null,
  setPlans: (plans) => set({ plans, error: null }),
  setStatus: (status) => set({ status, error: null }),
  setLoadingPlans: (isLoadingPlans) => set({ isLoadingPlans }),
  setLoadingStatus: (isLoadingStatus) => set({ isLoadingStatus }),
  setError: (error) => set({ error }),
}));

export default useSubscriptionStore;
